import { render, staticRenderFns } from "./googleoauth.vue?vue&type=template&id=54d3fd15&scoped=true&"
import script from "./googleoauth.vue?vue&type=script&lang=js&"
export * from "./googleoauth.vue?vue&type=script&lang=js&"
import style0 from "./googleoauth.vue?vue&type=style&index=0&id=54d3fd15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d3fd15",
  null
  
)

export default component.exports